import EvaluatorLeadAdminItem from '../../../Domain/EvaluatorLeadAdminItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import EvaluatorLeadService from '../../../Services/EvaluatorLeadService';

export default class EditEvaluatorLeadWindowDescription {
  static titleForCreate = 'Add a new lead';
  static titleForEdit = 'Edit lead';
  static itemType = EvaluatorLeadAdminItem;
  static messageOnSuccess = (edited) =>
    edited.EvaluatorLeadId ? 'The lead has been updated.' : 'The lead has been created.';
  static serviceFunction = (edited) => EvaluatorLeadService.SaveEvaluatorLead(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Lead details',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Email',
          label: 'Email',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forEmailRequired,
        },
        {
          fieldName: 'Phone',
          label: 'Phone (optional)',
          className: 'col-12',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Country',
          label: 'Country (optional)',
          className: 'col-12',
          type: InputTypesEnum.CountryCodeSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'City',
          label: 'City (optional)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          // Only shown when creating (no id yet). When left empty the backend fills it with the creating user.
          fieldName: 'ReferredBy',
          label: 'Referred By (optional)',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (editedItem) => !!editedItem.EvaluatorLeadId,
        },
      ],
    },
  ];
}
